export default __webpack_public_path__ + "static/media/Rectangle 20.3da03688.png";